@if (showContent()) {
  <div class="description-content-card">
    <div class="description-content-card-header">
      <div class="header-top">
        <div class="header-text">
          <span class="title">{{
            'tlc.positions.position_details_dialog.tabs.description.edit.position_description'
              | translate
          }}</span>
          <span class="subtitle">{{ positionData()?.name }}</span>
        </div>
        @if (canManageStructure()) {
          <rt-button class="edit-button" variant="tertiary" size="small" (click)="onEdit()">
            <rt-icon name="edit" />
            <span>{{ 'tlc.common.edit' | translate }}</span>
          </rt-button>
        }
      </div>
    </div>
    <div
      prosemirrorPositionDescriptionConfig
      [prosemirrorRender]="descriptionJsonValue"
      [prosemirrorRenderConfig]="ProsemirrorPositionDescriptionConfig"
      class="description-content"
    ></div>
  </div>
} @else if (showEditor()) {
  <div class="description-card">
    <div class="description-card-header">
      <div class="header-top">
        <span class="title">{{
          'tlc.positions.position_details_dialog.tabs.description.edit.title' | translate
        }}</span>
        @if (!hasDescriptionContent() && hasPaidCoreHrSubscription()) {
          <rt-create-with-ai-button
            [scope]="{ scope: 'description', isAccountVerified: isAccountVerified() }"
            context="prosemirror"
            buttonVariant="tertiary"
            (click)="onWriteWithAi()"
          />
        }
      </div>
    </div>
    <rt-wysiwyg
      prosemirrorPositionDescriptionConfig
      [rtProtectedControl]="descriptionJson"
      [config]="ProsemirrorPositionDescriptionConfig"
      [formControl]="descriptionJson"
      [withMinHeight]="true"
      [footerTmpl]="footerTemplate"
      [toolbarVisible]="false"
      [autofocus]="true"
    />
    <div class="description-card-footer">
      <span class="visibility">{{
        'tlc.positions.position_details_dialog.tabs.description.edit.visibility' | translate
      }}</span>
      <div class="actions">
        <rt-button variant="tertiary" (click)="onCancel()"
          >{{ 'tlc.positions.position_details_dialog.tabs.description.edit.cancel' | translate }}
        </rt-button>
        <rt-button variant="primary" (click)="onSave()" [loading]="loading()"
          >{{ 'tlc.positions.position_details_dialog.tabs.description.edit.save' | translate }}
        </rt-button>
      </div>
    </div>
  </div>
} @else if (showContent()) {
  <div class="description-view-card">
    <div class="description-view-card-header">
      <div class="description-info-container">
        <span class="title">{{
          'tlc.positions.position_details_dialog.tabs.description.edit.title' | translate
        }}</span>
        <span>{{ positionData()?.name }}</span>
      </div>
      <rt-button variant="tertiary" size="small" (click)="onEdit()">
        <rt-icon prefix name="edit" />
        <span>{{
          'tlc.positions.position_details_dialog.tabs.description.edit.edit' | translate
        }}</span>
      </rt-button>
    </div>
    <div
      class="description-content"
      prosemirrorPositionDescriptionConfig
      [prosemirrorRender]="$any(descriptionJson.value)"
      [prosemirrorRenderConfig]="ProsemirrorPositionDescriptionConfig"
    ></div>
  </div>
} @else {
  <div class="empty-state-container">
    <rt-empty-state
      icon="positions"
      [title]="
        'tlc.positions.position_details_dialog.tabs.description.empty_state.title' | translate
      "
      [desc]="
        'tlc.positions.position_details_dialog.tabs.description.empty_state.subtitle' | translate
      "
    >
      @if (canManageStructure()) {
        <div class="buttons-container">
          <rt-button variant="tertiary" (click)="onAddDescription()">
            <rt-icon name="add" />
            <span>{{
              'tlc.positions.position_details_dialog.tabs.description.empty_state.add_description'
                | translate
            }}</span>
          </rt-button>
          @if (hasPaidCoreHrSubscription()) {
            <rt-button variant="tertiary" (click)="onGenerateWithAi()">
              <rt-ai-logo size="small-x" />
              <span>{{
                'tlc.positions.position_details_dialog.tabs.description.empty_state.generate_with_ai'
                  | translate
              }}</span>
            </rt-button>
          }
        </div>
      }
    </rt-empty-state>
  </div>
}

<ng-template #aiFooterTemplate let-toolbar="toolbar">
  @if (showAiPanel()) {
    <tlc-position-description-insert-ai-message [isLoading]="aiIsLoading()" />
  }
  <div class="toolbar-wrapper">
    <ng-container *ngTemplateOutlet="toolbar" />
  </div>
</ng-template>
